/* Main product — gallery, variant picker, quantity */
(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var picker = root.querySelector('[data-variant-picker]');
    var input = root.querySelector('[data-variant-input]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = addButton ? addButton.querySelector('[data-button-label]') : null;
    var addText = addLabel ? addLabel.textContent.trim() : '';
    var priceEl = root.querySelector('[data-price]');
    var baseUrl = root.getAttribute('data-url');

    /* ---------- gallery ---------- */
    var items = root.querySelectorAll('[data-media-id]');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function showMedia(id) {
      if (!id) return;
      id = String(id);
      var found = false;
      items.forEach(function (item) {
        var active = item.getAttribute('data-media-id') === id;
        if (active) found = true;
        item.hidden = !active;
        if (!active) {
          item.querySelectorAll('video').forEach(function (v) { v.pause(); });
        }
      });
      if (!found && items[0]) items[0].hidden = false;
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-thumb') === id;
        t.classList.toggle('is-active', active);
        if (active) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-thumb'));
      });
    });

    /* ---------- variant picker ---------- */
    function selectedOptions() {
      if (!picker) return [];
      return Array.prototype.map.call(picker.querySelectorAll('[data-option-index]'), function (fs) {
        var active = fs.querySelector('.productDetails-flavourBtn.is-active');
        return active ? active.getAttribute('data-option-value') : null;
      });
    }

    function findVariant(options) {
      return data.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
    }

    // mark option values that can't be bought with the other current selections
    function updateAvailability(options) {
      if (!picker || data.optionCount < 2) return;
      picker.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var index = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var value = btn.getAttribute('data-option-value');
          var available = data.variants.some(function (v) {
            return v.available && v.options[index] === value && v.options.every(function (o, i) {
              return i === index || o === options[i];
            });
          });
          btn.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function applyVariant(variant) {
      if (addButton) {
        if (!variant) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = window.themeStrings.unavailable;
        } else {
          addButton.disabled = !variant.available;
          if (addLabel) addLabel.textContent = variant.available ? addText || window.themeStrings.addToCart : data.soldOut;
        }
      }
      if (!variant) return;
      if (input) input.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price;
      if (variant.mediaId) showMedia(variant.mediaId);
      if (baseUrl && window.history.replaceState) {
        window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
      }
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    if (picker) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || btn.disabled) return;
        var fs = btn.closest('[data-option-index]');
        fs.querySelectorAll('[data-option-value]').forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var options = selectedOptions();
        updateAvailability(options);
        applyVariant(findVariant(options));
      });
      updateAvailability(selectedOptions());
    }

    /* ---------- quantity ---------- */
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = btn.parentNode.querySelector('input[name="quantity"]');
        if (!field) return;
        var next = (parseInt(field.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        field.value = Math.max(1, next);
      });
    });
  }

  if (window.Anagenesis && window.Anagenesis.register) {
    window.Anagenesis.register('main-product', init);
  }
})();
